import { Expense } from "@finway-group/shared/lib/models"
import { Tag } from "antd"
import React from "react"
import { Archive } from "react-feather"
import { useTranslation } from "react-i18next"
import { isExpenseArchived, isExpenseManuallyUnarchived } from "~Shared/utils/expense.utils"

interface ExpenseArchiveTagsProps {
    expense: Expense
}

export const ExpenseArchiveTags = ({ expense }: ExpenseArchiveTagsProps) => {
    const { t } = useTranslation()

    return (
        <>
            {isExpenseArchived(expense) ? (
                <Tag className="ant-tag-blue flex flex-row">
                    <Archive className="self-center" size={12} />
                    <span className="ml-5"> {t("label:archived")}</span>
                </Tag>
            ) : (
                isExpenseManuallyUnarchived(expense) && (
                    <Tag className="ant-tag-blue flex flex-row">
                        <Archive className="self-center" size={12} />
                        <span className="ml-5"> {t("label:manually_unarchived")}</span>
                    </Tag>
                )
            )}
        </>
    )
}
